import React, { useState } from "react"
import { PrimaryButton, SEO, TextField } from "shared/components"
import { SMALL_SCREEN_MEDIA_QUERY } from "shared/helpers/responsive_helpers"
import styled from "styled-components"
import { Layout, PageHero, Title1, Title2LG, Title3VariableTextSize } from "../components"
import heroImage from "../images/happy-father-with-his-son-playing-at-home-on-the-PL755ZD.jpg"
import { GREY_COLOR, PRIMARY_COLOR_100, WHITE_COLOR } from "../styles"


const ContactForm = styled.form`
  display: grid;
  grid-template-areas:
    "name"
    "email"
    "phone"
    "subject"
    "message"
    "submit";
  grid-template-columns: 1fr;
  grid-template-rows: auto;

  @media ${ SMALL_SCREEN_MEDIA_QUERY} {
    grid-gap: 2rem;
    grid-template-areas:
      "name email"
      "phone subject"
      "message message"
      "submit .";
    grid-template-columns: 1fr 1fr;

  }
`

const NameField = styled.div`
  grid-area: name;
`

const EmailField = styled.div`
  grid-area: email;
`

const PhoneField = styled.div`
  grid-area: phone;
`

const SubjectField = styled.div`
  grid-area: subject;
`

const MessageField = styled.div`
  grid-area: message;
`

const SubmitField = styled.div`
  grid-area: submit;
`

const ContactPage = () => {

  const[name, setName] = useState( "" )
  const[email, setEmail] = useState( "" )
  const[phone, setPhone] = useState( "" )
  const[subject, setSubject] = useState( "" )
  const[message, setMessage] = useState( "" )
  const[formSubmitted, setFormSubmitted] = useState( false )
  const[errorMessage, setErrorMessage] = useState<null | string > ( null )

  const handleSubmit = ( event: React.FormEvent<HTMLFormElement> ) => {
  event.preventDefault()

  fetch( "https://submit-form.com/nq7-F8iFREJVaRws7qSZ0", {
    method: "POST",
    headers: {
      "Accept": "application/json",
      "Content-Type": "application/json"
    },
    body: JSON.stringify( {
      "Name": name,
      "Email": email,
      "Phone": phone,
      "Subject": subject,
      "Message": message
    } )
  } )
    .then( () => setFormSubmitted( true ) )
    .catch( () => setErrorMessage( "Sorry, an unknown error occurred" ) )
}

  return (
      <Layout>
        <SEO title="Cuzy | Contact Us" description="Get in touch!" />
        <PageHero
          backgroundImage={ heroImage }
          positionY="70%"
          // tslint:disable-next-line: jsx-no-lambda
          renderContent={ () => (
            <div className="flex flex-col items-center pt-20">
              <Title1 className="text-center mb-5">Contact our Care Team</Title1>
              <Title3VariableTextSize textSize="1.5rem" className="text-primary-100 font-bold text-center">Have Questions? We've Got Answers.</Title3VariableTextSize>
            </div>
          ) }
        />
        <div className="flex flex-col lg:flex-row">
          <div className="lg:w-1/2 lg:py-20">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d73888.26140643202!2d-79.57917102802793!3d43.82365011510763!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882b2f787dbf322b%3A0x8c567f928162cbbd!2s8611%20Weston%20Rd%20Unit%2023%20A%2C%20Woodbridge%2C%20ON%20L4L%209P1!5e0!3m2!1sen!2sca!4v1584364160119!5m2!1sen!2sca"
              className="w-full h-64 lg:h-full"
              aria-hidden="false"
            />
          </div>

          <div className="lg:w-1/2 py-20 px-4 lg:px-20">
            <Title2LG className="text-primary-100 mb-8">Send us A Message</Title2LG>
            <ContactForm onSubmit={ handleSubmit }>
              { formSubmitted ? (
                errorMessage ? (
                  <div className="bg-orange-lightest border-l-4 border-orange text-orange-dark p-4">
                    { errorMessage }
                  </div>
                ) : (
                  <div className="bg-teal-100 border-l-4 border-teal-500 text-teal-700 p-4 my-6">
                      Thanks for getting in touch! We will get back to you shortly.
                    </div>
                  )
                  ) : (
                    <>
                    <NameField>
                      <TextField
                        inputStyle="line"
                        inputStyleColor={ GREY_COLOR }
                        label="Name"
                        name="name"
                        // tslint:disable-next-line: jsx-no-lambda
                        onChange={ ( e ) => setName( e.target.value ) }
                        placeholder="Name"
                        value={ name }
                        required={ true }
                        labelStyle={ {
                          position: "absolute",
                          overflow: "hidden",
                          clip: "rect(0 0 0 0)",
                          height: "1px",
                          width: "1px",
                          margin: "-1px",
                          padding: "0",
                          border: "0"
                        } }
                      />
                    </NameField>

                    <EmailField>
                      <TextField
                        inputStyle="line"
                        inputStyleColor={ GREY_COLOR }
                        label="Email"
                        name="email"
                        // tslint:disable-next-line: jsx-no-lambda
                        onChange={ ( e ) => setEmail( e.target.value ) }
                        placeholder="Email"
                        value={ email }
                        type="email"
                        required={ true }
                        labelStyle={ {
                          position: "absolute",
                          overflow: "hidden",
                          clip: "rect(0 0 0 0)",
                          height: "1px",
                          width: "1px",
                          margin: "-1px",
                          padding: "0",
                          border: "0"
                        } }
                      />
                    </EmailField>

                    <PhoneField>
                      <TextField
                        inputStyle="line"
                        inputStyleColor={ GREY_COLOR }
                        label="Phone Number"
                        name="phoneNumber"
                        // tslint:disable-next-line: jsx-no-lambda
                        onChange={ ( e ) => setPhone( e.target.value ) }
                        placeholder="Phone Number"
                        value={ phone }
                        type="text"
                        required={ true }
                        labelStyle={ {
                          position: "absolute",
                          overflow: "hidden",
                          clip: "rect(0 0 0 0)",
                          height: "1px",
                          width: "1px",
                          margin: "-1px",
                          padding: "0",
                          border: "0"
                        } }
                      />
                    </PhoneField>

                    <SubjectField>
                      <TextField
                        inputStyle="line"
                        inputStyleColor={ GREY_COLOR }
                        label="Subject"
                        name="subject"
                        // tslint:disable-next-line: jsx-no-lambda
                        onChange={ ( e ) => setSubject( e.target.value ) }
                        placeholder="Subject"
                        value={ subject }
                        type="text"
                        required={ true }
                        labelStyle={ {
                          position: "absolute",
                          overflow: "hidden",
                          clip: "rect(0 0 0 0)",
                          height: "1px",
                          width: "1px",
                          margin: "-1px",
                          padding: "0",
                          border: "0"
                        } }
                      />
                    </SubjectField>

                    <MessageField>
                      <TextField
                        inputStyle="line"
                        inputStyleColor={ GREY_COLOR }
                        label="Message"
                        multiline={ true }
                        name="message"
                        // tslint:disable-next-line: jsx-no-lambda
                        onChange={ ( e ) => setMessage( e.target.value ) }
                        placeholder="Message"
                        rows="6"
                        value={ message }
                        labelStyle={ {
                          position: "absolute",
                          overflow: "hidden",
                          clip: "rect(0 0 0 0)",
                          height: "1px",
                          width: "1px",
                          margin: "-1px",
                          padding: "0",
                          border: "0"
                        } }
                      />
                    </MessageField>

                    <SubmitField>
                      <PrimaryButton
                        type="submit"
                        color={ PRIMARY_COLOR_100 }
                        colorHover={ WHITE_COLOR }
                        borderColorHover={ PRIMARY_COLOR_100 }
                        textColor={ WHITE_COLOR }
                        textColorHover={ PRIMARY_COLOR_100 }
                        className="rounded-full"
                      >
                        Send Message
                      </PrimaryButton>
                    </SubmitField>
                  </>
                ) }
            </ContactForm>
          </div>
        </div>
      </Layout>
    )

}

export default ContactPage
